/**
 * NBC — widget compartido de dirección (autocomplete, GPS, mapa, zona).
 * Usado por carrito-nbc (checkout) y pedidos-nbc (modal editar entrega epv2).
 */
(function (window) {
  'use strict';

  var MAP_ID = 'fe2877837045f6cad06a6561';
  var MAPA_OPTS_INLINE = {
    gestureHandling: 'none',
    zoomControl: false,
    draggable: false,
    scrollwheel: false,
    disableDoubleClickZoom: true
  };
  var MAPA_OPTS_MODAL = {
    gestureHandling: 'greedy',
    zoomControl: true,
    draggable: true,
    scrollwheel: true,
    disableDoubleClickZoom: false
  };

  var _mapsLoadPromise = null;
  var _poligonoCache = {};
  var _stylesInjected = false;

  function escHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escAttr(s) {
    return String(s || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'");
  }

  function injectSuggestionStyles() {
    if (_stylesInjected) return;
    _stylesInjected = true;
    var style = document.createElement('style');
    style.id = 'nbc-dir-suggestion-styles';
    style.textContent = [
      '.nbc-suggestion-item { padding:10px 12px;font-size:13px;cursor:pointer;border-bottom:1px solid var(--nbc-color-surface-muted);font-family:inherit;line-height:1.35; }',
      '.nbc-suggestion-item:last-child { border-bottom:none; }',
      '.nbc-suggestion-item:hover, .nbc-suggestion-item.nbc-suggestion-active { background:var(--nbc-color-surface-subtle); }',
      '.nbc-dir-suggestions-wrap { display:none;border:1px solid var(--nbc-color-border-default);border-radius:8px;margin-top:4px;background:var(--color-background);overflow:hidden;position:relative;z-index:99;max-height:220px;overflow-y:auto; }'
    ].join(' ');
    document.head.appendChild(style);
  }

  function loadPoligono(apiBase, intentos) {
    intentos = intentos || 0;
    var key = apiBase || 'default';
    if (_poligonoCache[key] && _poligonoCache[key].listo) {
      return Promise.resolve(_poligonoCache[key].data);
    }
    if (!_poligonoCache[key]) _poligonoCache[key] = { data: [], listo: false };
    return fetch((apiBase || '') + '/api/poligono')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!Array.isArray(data) || !data.length) throw new Error('vacío');
        _poligonoCache[key].data = data;
        _poligonoCache[key].listo = true;
        return data;
      })
      .catch(function () {
        if (intentos < 3) {
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve(loadPoligono(apiBase, intentos + 1));
            }, 2000);
          });
        }
        _poligonoCache[key].listo = true;
        return _poligonoCache[key].data;
      });
  }

  function getPoligono(apiBase) {
    var key = apiBase || 'default';
    return (_poligonoCache[key] && _poligonoCache[key].data) || [];
  }

  function puntoEnPoligono(poligono, lat, lng) {
    var dentro = false;
    for (var i = 0, j = poligono.length - 1; i < poligono.length; j = i++) {
      var pLng = poligono[i][0], pLat = poligono[i][1];
      var qLng = poligono[j][0], qLat = poligono[j][1];
      if (((pLat > lat) !== (qLat > lat))
        && (lng < (qLng - pLng) * (lat - pLat) / (qLat - pLat) + pLng)) {
        dentro = !dentro;
      }
    }
    return dentro;
  }

  function cargarGoogleMaps() {
    if (!window.NBC_GMAPS_FRONTEND_KEY) return Promise.resolve(false);
    if (window.google && window.google.maps) return Promise.resolve(true);
    if (_mapsLoadPromise) return _mapsLoadPromise;
    _mapsLoadPromise = new Promise(function (resolve) {
      var cbName = '__nbcDirMapsReady_' + Date.now();
      window[cbName] = function () {
        delete window[cbName];
        resolve(true);
      };
      var script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(window.NBC_GMAPS_FRONTEND_KEY)
        + '&loading=async&libraries=maps&callback=' + cbName;
      script.async = true;
      script.onerror = function () {
        _mapsLoadPromise = null;
        resolve(false);
      };
      document.head.appendChild(script);
    });
    return _mapsLoadPromise;
  }

  function crearMapaCentrado(store, canvasId, lat, lng, esModal) {
    if (!window.google || !window.google.maps) return null;
    var canvas = document.getElementById(canvasId);
    if (!canvas) return null;

    var pos = { lat: parseFloat(lat), lng: parseFloat(lng) };
    var map = esModal ? store.modalMap : store.inlineMap;

    if (map) {
      google.maps.event.clearListeners(map, 'idle');
      map.setOptions(esModal ? MAPA_OPTS_MODAL : MAPA_OPTS_INLINE);
      map.setCenter(pos);
      if (esModal && store.onMapIdle) {
        store.modalIdleListener = map.addListener('idle', function () {
          store.onMapIdle(map);
        });
      }
      return map;
    }

    canvas.innerHTML = '';
    map = new google.maps.Map(canvas, Object.assign({
      center: pos,
      zoom: 17,
      disableDefaultUI: true,
      clickableIcons: false,
      mapId: MAP_ID
    }, esModal ? MAPA_OPTS_MODAL : MAPA_OPTS_INLINE));

    if (window.nbcInitMapaEstilo) window.nbcInitMapaEstilo(map);

    if (esModal) {
      store.modalMap = map;
      if (store.onMapIdle) {
        store.modalIdleListener = map.addListener('idle', function () {
          store.onMapIdle(map);
        });
      }
    } else {
      store.inlineMap = map;
    }
    return map;
  }

  function ocultarMapa(store, ids) {
    if (ids.mapContenedor) {
      var cont = document.getElementById(ids.mapContenedor);
      if (cont) cont.style.display = 'none';
    }
    if (ids.mapHint) {
      var hint = document.getElementById(ids.mapHint);
      if (hint) hint.style.display = 'none';
    }
    if (ids.mapModal) {
      var modal = document.getElementById(ids.mapModal);
      if (modal) modal.classList.remove('activo');
    }
    document.body.style.overflow = '';

    if (store.inlineMap) {
      google.maps.event.clearListeners(store.inlineMap, 'idle');
      store.inlineMap = null;
    }
    if (store.modalMap) {
      google.maps.event.clearListeners(store.modalMap, 'idle');
      store.modalMap = null;
    }
    if (ids.mapCanvas) {
      var c = document.getElementById(ids.mapCanvas);
      if (c) c.innerHTML = '';
    }
    if (ids.mapModalCanvas) {
      var cm = document.getElementById(ids.mapModalCanvas);
      if (cm) cm.innerHTML = '';
    }
  }

  function mostrarZonaMsg(el, mode, htmlOrText) {
    if (!el) return;
    if (mode === 'hide') {
      el.style.display = 'none';
      return;
    }
    el.style.display = 'block';
    if (mode === 'loading') {
      el.style.background = 'var(--nbc-color-surface-muted)';
      el.style.border = '1px solid var(--nbc-color-border-default)';
      el.style.color = 'var(--nbc-color-text-tertiary)';
      el.textContent = htmlOrText || 'Verificando cobertura…';
    } else if (mode === 'error') {
      el.style.background = 'var(--nbc-color-error-bg)';
      el.style.border = '1px solid var(--nbc-color-error-border)';
      el.style.color = 'var(--nbc-color-error-text)';
      if (htmlOrText && htmlOrText.indexOf('<') >= 0) el.innerHTML = htmlOrText;
      else el.textContent = htmlOrText || 'Error al verificar la dirección.';
    }
  }

  function parseAddressComponents(data, descripcionOpt) {
    var comps = data.address_components || [];
    function getComp(type) {
      var c = comps.find(function (comp) { return comp.types && comp.types.indexOf(type) >= 0; });
      return c ? c.long_name : '';
    }
    return {
      calleTexto: getComp('route') || getComp('establishment')
        || (descripcionOpt ? descripcionOpt.split(',')[0].trim() : 'Ubicación GPS'),
      coloniaTexto: getComp('sublocality_level_1') || getComp('sublocality') || getComp('neighborhood') || '',
      numeroTexto: getComp('street_number') || '',
      data: data
    };
  }

  function buildDireccionLinea(calle, numero, colonia) {
    return [calle, numero, colonia].filter(Boolean).join(', ');
  }

  function buildDireccionCompleta(calle, numero, colonia) {
    return [calle, numero, colonia, 'Chihuahua, Mexico'].filter(Boolean).join(', ');
  }

  function msgFueraZona(recoleccionHint) {
    var base = '✕ Tu dirección está fuera de nuestra zona de entrega.';
    if (recoleccionHint) {
      return base + '<br><small>Puedes seleccionar <strong>Recolección en tienda</strong> sin costo.</small>';
    }
    return base + ' Puedes elegir <strong>Recolección en tienda</strong>.';
  }

  function renderSuggestions(container, sugs, onSelect) {
    if (!container) return;
    injectSuggestionStyles();
    if (!sugs.length) {
      container.style.display = 'none';
      container.innerHTML = '';
      return;
    }
    container.className = (container.className || '').replace(/\bepv2-search-results\b/g, '').trim()
      + ' nbc-dir-suggestions-wrap';
    container.style.display = 'block';
    container.innerHTML = sugs.map(function (s, idx) {
      var desc = s.description || s.text || '';
      return '<div class="nbc-suggestion-item" data-idx="' + idx + '" role="option" tabindex="-1">'
        + escHtml(desc) + '</div>';
    }).join('');

    container.querySelectorAll('.nbc-suggestion-item').forEach(function (item, idx) {
      item.addEventListener('click', function () {
        onSelect(sugs[idx]);
      });
    });
  }

  function hideSuggestions(container) {
    if (!container) return;
    container.style.display = 'none';
  }

  /**
   * Monta el widget de dirección sobre IDs existentes.
   * @param {Object} cfg
   * @returns {{ destroy: Function, showMap: Function, getState: Function }}
   */
  function mount(cfg) {
    injectSuggestionStyles();
    var apiBase = cfg.apiBase || window.NBC_API || '';
    var ids = cfg.ids || {};
    var recoleccionHint = cfg.recoleccionHint !== false;
    var revalidateOnMapIdle = !!cfg.revalidateOnMapIdle;
    var hideGpsOnSuccess = cfg.hideGpsOnSuccess !== false;

    var state = {
      validated: false,
      lat: null,
      lng: null,
      direccion: '',
      direccionDisplay: '',
      components: null,
      geocodeData: null
    };

    var store = { inlineMap: null, modalMap: null, modalIdleListener: null };
    var debounceTimer = null;
    var clickOutsideHandler = null;
    var destroyed = false;

    function el(id) { return id ? document.getElementById(id) : null; }

    function emitValidated() {
      state.validated = true;
      if (cfg.onValidated) cfg.onValidated(Object.assign({}, state));
    }

    function emitInvalidated() {
      state.validated = false;
      if (cfg.onInvalidated) cfg.onInvalidated();
    }

    function syncCoordsFromMap(map) {
      if (!map) return;
      var center = map.getCenter();
      if (!center) return;
      var lat = center.lat();
      var lng = center.lng();
      state.lat = lat;
      state.lng = lng;

      if (!revalidateOnMapIdle) {
        if (cfg.onCoordsUpdated) cfg.onCoordsUpdated({ lat: lat, lng: lng });
        return;
      }

      var poligono = getPoligono(apiBase);
      var zonaEl = el(ids.zonaMsg);
      if (!puntoEnPoligono(poligono, lat, lng)) {
        mostrarZonaMsg(zonaEl, 'error', msgFueraZona(recoleccionHint));
        emitInvalidated();
        return;
      }

      mostrarZonaMsg(zonaEl, 'loading', 'Actualizando ubicación…');
      fetch(apiBase + '/api/geocodificar?latlng=' + lat + ',' + lng)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var parsed = parseAddressComponents(data);
          state.components = parsed;
          state.geocodeData = data;
          state.direccionDisplay = buildDireccionLinea(parsed.calleTexto, parsed.numeroTexto, parsed.coloniaTexto);
          state.direccion = state.direccionDisplay;
          var addrInput = el(ids.addrInput);
          if (addrInput) addrInput.value = state.direccionDisplay;
          var linea = el(ids.direccionLinea);
          if (linea) linea.textContent = state.direccionDisplay;
          mostrarZonaMsg(zonaEl, 'hide');
          emitValidated();
        })
        .catch(function () {
          mostrarZonaMsg(zonaEl, 'error', 'No pudimos actualizar la dirección. Intenta de nuevo.');
          emitInvalidated();
        });
    }

    store.onMapIdle = syncCoordsFromMap;

    function showMap(lat, lng) {
      if (!ids.mapCanvas || !window.NBC_GMAPS_FRONTEND_KEY) return Promise.resolve();
      var contenedor = el(ids.mapContenedor);
      var hint = el(ids.mapHint);
      if (contenedor) contenedor.style.display = 'block';
      if (hint) hint.style.display = 'block';

      return cargarGoogleMaps().then(function (ok) {
        if (!ok || destroyed) return;
        return google.maps.importLibrary('maps').then(function () {
          crearMapaCentrado(store, ids.mapCanvas, lat, lng, false);
        });
      }).catch(function () { /* ignore */ });
    }

    function abrirMapaModal() {
      if (!state.lat || !state.lng || !ids.mapModal) return;
      var modal = el(ids.mapModal);
      modal.classList.add('activo');
      document.body.style.overflow = 'hidden';

      cargarGoogleMaps().then(function (ok) {
        if (!ok || destroyed) return;
        return google.maps.importLibrary('maps').then(function () {
          var map = crearMapaCentrado(store, ids.mapModalCanvas, state.lat, state.lng, true);
          requestAnimationFrame(function () {
            if (map) {
              google.maps.event.trigger(map, 'resize');
              map.setCenter({ lat: parseFloat(state.lat), lng: parseFloat(state.lng) });
            }
          });
        });
      }).catch(function () { /* ignore */ });
    }

    function cerrarMapaModal() {
      var modal = el(ids.mapModal);
      if (modal) modal.classList.remove('activo');
      document.body.style.overflow = '';

      if (store.modalMap && store.inlineMap && state.lat != null) {
        store.inlineMap.setCenter({ lat: parseFloat(state.lat), lng: parseFloat(state.lng) });
        google.maps.event.trigger(store.inlineMap, 'resize');
      }
    }

    function aplicarGeocodificado(data, descripcionOpt) {
      var parsed = parseAddressComponents(data, descripcionOpt);
      state.components = parsed;
      state.geocodeData = data;
      state.lat = data.lat;
      state.lng = data.lng;
      state.direccionDisplay = buildDireccionLinea(parsed.calleTexto, parsed.numeroTexto, parsed.coloniaTexto);
      state.direccion = descripcionOpt || state.direccionDisplay;

      var linea = el(ids.direccionLinea);
      if (linea) linea.textContent = state.direccionDisplay;

      var confirmada = el(ids.dirConfirmada);
      if (confirmada) confirmada.style.display = 'block';

      emitValidated();
      showMap(state.lat, state.lng);

      if (hideGpsOnSuccess) {
        var gpsBtn = el(ids.gpsBtn);
        if (gpsBtn) gpsBtn.style.display = 'none';
      }
    }

    function seleccionarPlace(placeId, descripcion) {
      var addrInput = el(ids.addrInput);
      var suggestions = el(ids.suggestions);
      var zonaEl = el(ids.zonaMsg);
      if (addrInput) addrInput.value = descripcion;
      hideSuggestions(suggestions);
      mostrarZonaMsg(zonaEl, 'loading');

      fetch(apiBase + '/api/geocodificar?place_id=' + encodeURIComponent(placeId))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.lat || !data.lng) throw new Error('Sin coordenadas');
          var poligono = getPoligono(apiBase);
          if (!puntoEnPoligono(poligono, data.lat, data.lng)) {
            mostrarZonaMsg(zonaEl, 'error', msgFueraZona(recoleccionHint));
            emitInvalidated();
            return;
          }
          mostrarZonaMsg(zonaEl, 'hide');
          aplicarGeocodificado(data, descripcion);
        })
        .catch(function () {
          mostrarZonaMsg(zonaEl, 'error', 'Error al verificar la dirección. Intenta de nuevo.');
          emitInvalidated();
        });
    }

    function onAddrInput(valor) {
      clearTimeout(debounceTimer);
      emitInvalidated();
      state.lat = null;
      state.lng = null;
      ocultarMapa(store, ids);

      if (!valor || valor.length < 3) {
        hideSuggestions(el(ids.suggestions));
        return;
      }
      debounceTimer = setTimeout(function () {
        fetch(apiBase + '/api/places-autocomplete?input=' + encodeURIComponent(valor))
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var sugs = data.predictions || data.suggestions || [];
            renderSuggestions(el(ids.suggestions), sugs, function (s) {
              seleccionarPlace(s.place_id, s.description || s.text || '');
            });
          })
          .catch(function () { /* ignore */ });
      }, 300);
    }

    function usarUbicacionActual() {
      var spinner = el(ids.gpsSpinner);
      var gpsBtn = el(ids.gpsBtn);
      var zonaEl = el(ids.zonaMsg);
      if (spinner) spinner.style.display = 'inline';
      if (!navigator.geolocation) {
        if (spinner) spinner.style.display = 'none';
        mostrarZonaMsg(zonaEl, 'error', 'Tu navegador no soporta geolocalización.');
        return;
      }
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          var lat = pos.coords.latitude;
          var lng = pos.coords.longitude;
          if (spinner) spinner.style.display = 'none';
          var poligono = getPoligono(apiBase);
          if (!puntoEnPoligono(poligono, lat, lng)) {
            mostrarZonaMsg(zonaEl, 'error', msgFueraZona(recoleccionHint));
            emitInvalidated();
            return;
          }
          fetch(apiBase + '/api/geocodificar?latlng=' + lat + ',' + lng)
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var parsed = parseAddressComponents(data);
              var display = buildDireccionLinea(parsed.calleTexto, parsed.numeroTexto, parsed.coloniaTexto);
              var addrInput = el(ids.addrInput);
              if (addrInput) addrInput.value = display;
              mostrarZonaMsg(zonaEl, 'hide');
              aplicarGeocodificado(Object.assign({ lat: lat, lng: lng }, data), display);
            })
            .catch(function () {
              if (spinner) spinner.style.display = 'none';
              mostrarZonaMsg(zonaEl, 'error', 'No pudimos obtener tu dirección. Intenta de nuevo.');
            });
        },
        function (err) {
          if (spinner) spinner.style.display = 'none';
          if (err && err.code === 1) {
            mostrarZonaMsg(zonaEl, 'error', 'Permiso de ubicación denegado. Actívalo en tu navegador o escribe la dirección.');
          } else {
            mostrarZonaMsg(zonaEl, 'error', 'No pudimos obtener tu ubicación. Verifica tu señal GPS o escribe la dirección.');
          }
        },
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
      );
    }

    // Bind inputs
    var addrInput = el(ids.addrInput);
    if (addrInput) {
      addrInput.addEventListener('input', function () { onAddrInput(addrInput.value); });
      if (cfg.initial && cfg.initial.direccion) addrInput.value = cfg.initial.direccion;
    }

    var gpsBtn = el(ids.gpsBtn);
    if (gpsBtn) {
      gpsBtn.addEventListener('click', usarUbicacionActual);
    }

    var ampliarBtn = el(ids.mapAmpliarBtn);
    if (ampliarBtn) {
      ampliarBtn.addEventListener('click', abrirMapaModal);
    }

    var modalCerrar = el(ids.mapModalCerrar);
    if (modalCerrar) modalCerrar.addEventListener('click', cerrarMapaModal);
    var modalConfirmar = el(ids.mapModalConfirmar);
    if (modalConfirmar) modalConfirmar.addEventListener('click', cerrarMapaModal);

    // Click outside suggestions
    clickOutsideHandler = function (e) {
      var suggestions = el(ids.suggestions);
      var input = el(ids.addrInput);
      if (!suggestions || suggestions.style.display === 'none') return;
      if (suggestions.contains(e.target) || (input && input.contains(e.target))) return;
      hideSuggestions(suggestions);
    };
    document.addEventListener('click', clickOutsideHandler);

    loadPoligono(apiBase);

    // Initial validated state with coords → show map
    if (cfg.initial && cfg.initial.validated && cfg.initial.lat != null && cfg.initial.lng != null) {
      state.validated = true;
      state.lat = cfg.initial.lat;
      state.lng = cfg.initial.lng;
      state.direccion = cfg.initial.direccion || '';
      state.direccionDisplay = cfg.initial.direccion || '';
      showMap(state.lat, state.lng);
      if (hideGpsOnSuccess && gpsBtn) gpsBtn.style.display = 'none';
    }

    return {
      getState: function () { return Object.assign({}, state); },
      showMap: showMap,
      seleccionarPlace: seleccionarPlace,
      onAddrInput: onAddrInput,
      usarUbicacionActual: usarUbicacionActual,
      abrirMapaModal: abrirMapaModal,
      cerrarMapaModal: cerrarMapaModal,
      destroy: function () {
        destroyed = true;
        clearTimeout(debounceTimer);
        if (clickOutsideHandler) document.removeEventListener('click', clickOutsideHandler);
        ocultarMapa(store, ids);
      }
    };
  }

  var _globalClickOutsideBound = false;

  function bindSuggestionsClickOutside(inputId, suggestionsId) {
    if (_globalClickOutsideBound) return;
    _globalClickOutsideBound = true;
    document.addEventListener('click', function (e) {
      var suggestions = document.getElementById(suggestionsId);
      var input = document.getElementById(inputId);
      if (!suggestions || suggestions.style.display === 'none') return;
      if (suggestions.contains(e.target) || (input && input.contains(e.target))) return;
      hideSuggestions(suggestions);
    });
  }

  window.NbcDirCore = {
    MAP_ID: MAP_ID,
    MAPA_OPTS_INLINE: MAPA_OPTS_INLINE,
    MAPA_OPTS_MODAL: MAPA_OPTS_MODAL,
    injectSuggestionStyles: injectSuggestionStyles,
    escHtml: escHtml,
    escAttr: escAttr,
    loadPoligono: loadPoligono,
    getPoligono: getPoligono,
    puntoEnPoligono: puntoEnPoligono,
    cargarGoogleMaps: cargarGoogleMaps,
    crearMapaCentrado: crearMapaCentrado,
    ocultarMapa: ocultarMapa,
    mostrarZonaMsg: mostrarZonaMsg,
    parseAddressComponents: parseAddressComponents,
    buildDireccionLinea: buildDireccionLinea,
    buildDireccionCompleta: buildDireccionCompleta,
    msgFueraZona: msgFueraZona,
    renderSuggestions: renderSuggestions,
    hideSuggestions: hideSuggestions,
    bindSuggestionsClickOutside: bindSuggestionsClickOutside,
    mount: mount
  };
})(window);
